// useProductSearch.ts
import { useState, useCallback } from 'react';
import debounce from 'lodash/debounce';
import logger, { Logger } from '../utils/logger';

export const useProductSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  // Debounced search handler
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      logger.log('🔍 Debounced search term:', value);
      setDebouncedSearchTerm(value);
    }, 300),
    []
  );

  // Handle search change
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    logger.log('🔍 Search input changed:', value);
    setSearchTerm(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  // Clear search
  const handleClearSearch = useCallback(() => {
    logger.log('🔍 Clearing search');
    setSearchTerm('');
    debouncedSearch('');
  }, [debouncedSearch]);

  // Reset search on open
  const resetSearch = useCallback(() => {
    logger.log('🔍 Resetting search');
    setSearchTerm('');
    setDebouncedSearchTerm('');
  }, []);

  return {
    searchTerm,
    debouncedSearchTerm,
    handleSearchChange,
    handleClearSearch,
    resetSearch
  };
};